export default __webpack_public_path__ + "static/media/yoga-brain.6390ef1a.png";